import Vue from 'vue';
const PaymentBus = new Vue();
export default PaymentBus;
